import {USER_DATE_FORMAT} from "shared/constants/date";

export const MULTIPLE_VALUE_SPLITTER = " | ";
export const MULTIPLE_VALUE_JOINER = ", ";
export const VALUE_DATE_FORMAT = USER_DATE_FORMAT;
